module.exports = __webpack_public_path__ + "static/media/ad-amazon-vertical.e55c0744.png";